export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGOUT = "LOGOUT";
export const PROFILE = "PROFILE";
export const MASTER_PROFILE = "MASTER_PROFILE";
